import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api, { eur, formatApiError } from "@/lib/api";

export default function Paga() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const t = sp.get("t") || "";
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/public/pay/${id}?t=${encodeURIComponent(t)}`).then((r) => setD(r.data)).catch((e) => setErr(formatApiError(e))); }, [id, t]);
  const pay = async () => {
    setBusy(true);
    try { window.location.href = (await api.post(`/public/pay/${id}/checkout`, { t, origin_url: window.location.origin })).data.checkout_url; }
    catch (e) { setErr(formatApiError(e)); setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-cyan-100 flex items-center justify-center p-4" data-testid="pay-page">
      <div className="bg-white rounded-2xl shadow-lg p-6 max-w-md w-full text-center">
        <img src="/blu-lodge-logo.png" alt="" className="h-14 mx-auto mb-3" onError={(e) => { e.currentTarget.style.display = "none"; }} />
        <h1 className="text-xl font-bold text-slate-900">Blu Lodge Maldives</h1>
        {err && <p className="text-sm text-rose-600 mt-4" data-testid="pay-error">{err}</p>}
        {d && (
          <>
            <p className="text-sm text-slate-600 mt-2">{d.guest} · {d.checkin} → {d.checkout}</p>
            {d.next_due ? (
              <>
                <div className="mt-5 text-sm text-slate-500">{d.next_due.label}</div>
                <div className="text-3xl font-bold text-sky-800" data-testid="pay-amount">{eur(d.next_due.amount)}</div>
                <button data-testid="pay-button" onClick={pay} disabled={busy} className="mt-5 w-full py-3 rounded-xl bg-sky-700 text-white font-semibold hover:bg-sky-800">
                  {busy ? "Apertura pagamento…" : "Paga con carta"}
                </button>
                <p className="text-[11px] text-slate-400 mt-3">Pagamento sicuro con Stripe · Secure card payment</p>
              </>
            ) : <p className="mt-5 text-emerald-700 font-semibold" data-testid="pay-done">Tutto pagato, grazie! · Fully paid, thank you!</p>}
          </>
        )}
      </div>
    </div>
  );
}
